export default {"src":"/_next/static/media/ViewIcon.6fdfbdef.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};